// eslint-disable-next-line max-classes-per-file
import { PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

export default class extends BaseApi {
  static entityName = 'contacts';

  accept(id) {
    const operation = new PostOperation(`/api/contacts/${id}/accept`, []);
    return this.execute(operation, true);
  }
}
